import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full bg-bg-dark py-5 md:py-8 px-4 sm:px-6 lg:px-8" data-id="element-319">
      <div className="max-w-[750px] mx-auto text-center" data-id="element-320">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-321">
          <h2 className="text-[28px] md:text-[32px] font-bold text-white mb-5 leading-[1.3]" data-id="element-322">
            57% of CO Poisoning Victims Had 'Working' Detectors. The Detectors
            Never Made a Sound.
          </h2>
          <div className="space-y-3 text-[16px] md:text-[18px] text-gray-300 leading-[1.45] mb-8 text-justify" data-id="element-323">
            <p data-id="element-324">
              Traditional CO detectors are designed to stay silent until CO
              reaches 70 to 150 PPM — near-fatal levels. By the time yours makes
              a sound, you and your family have already been breathing poison
              for hours.
            </p>
            <p data-id="element-325">
              But here's what makes it worse: most detectors expire after 5 to 7
              years. The sensor dies — but the green light stays on. That green
              light on your wall? It might be lying to you right now.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5" data-id="element-326">
          {[{
          num: '50,000+',
          label: 'Americans hospitalized for CO poisoning every year'
        }, {
          num: '90%',
          label: 'Of homes have detectors — yet poisonings keep rising'
        }, {
          num: '5-7 yrs',
          label: 'Average detector lifespan. Most homeowners never replace them.'
        }].map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.1
        }} className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-lg p-4 flex flex-col items-center" data-id="element-327">
              <div className="text-[36px] font-bold text-white mb-1.5 leading-none" data-id="element-328">
                {stat.num}
              </div>
              <p className="text-gray-300 text-[14px] leading-[1.45]" data-id="element-329">
                {stat.label}
              </p>
            </motion.div>)}
        </div>

        {/* 24/7 Protection Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-6" data-id="element-330">
          <img src="https://cdn.magicpatterns.com/uploads/tBbssZy6AdF1Qag6iNeftn/foto_24-7.png" alt="230 PPM CO reading in a real kitchen" className="w-full h-auto rounded-xl" data-id="element-331" />
          <p className="text-gray-400 text-[13px] italic text-center mt-2" data-id="element-332">
            This is what 230 PPM looks like in a real kitchen. Most detectors
            won't alarm until it's already too late.
          </p>
        </motion.div>
      </div>
    </section>;
}